import { api } from "../axios";

export const getListAvatarDecor = async (args: { size: number; offset: number }) => {
  const { size, offset } = args;
  return api.get('/decorations', { params: { size, offset } });
};

export const getAvatarDecorByUser = async (args: { size: number; offset: number }) => {
  const { size, offset } = args;
  return api.get('/decorations/user', { params: { size, offset } });
};

export const buyAvatarDecor = async (id: number) => {
  return api.post(`/decorations/${id}/buy`);
}

export const usedAvatarDecor = async (id: number) => {
  return api.patch(`/decorations/${id}/used`);
}